var FcDataCardModule = /** @class */ (function () {
    function FcDataCardModule() {
    }
    return FcDataCardModule;
}());
export { FcDataCardModule };
